import React from 'react'

import Icon from '../../../Shared/Icon/Icon'

function TopInfoBar() {
  return (
    <div className="content-section__content create-project__top-info">
      <div className="row">
        <div className="col-12 col-sm-6 col-md-3 create-project__step">
          <div className="create-project__step-icon">
            <Icon type={['fal', 'user']} size="3x" color="green-dark" />
          </div>
          <div className="create-project__step-text">
            The client will review your offer and make adjustments on Project details if needed
          </div>
          <div className="create-project__step-indicator">
            <Icon type={['far', 'angle-right']} color="grey" size="2x" />
          </div>
        </div>

        <div className="col-12 col-sm-6 col-md-3 create-project__step">
          <div className="create-project__step-icon">
            <Icon type={['fal', 'handshake']} size="3x" color="green-dark" />
          </div>
          <div className="create-project__step-text">
            You will be able to negotiate the price
          </div>
          <div className="create-project__step-indicator">
            <Icon type={['far', 'angle-right']} color="grey" size="2x" />
          </div>
        </div>

        <div className="col-12 col-sm-6 col-md-3 create-project__step">
          <div className="create-project__step-icon">
            <Icon type={['fal', 'credit-card']} size="3x" color="green-dark" />
          </div>
          <div className="create-project__step-text">
            You will be informed when the client prepays for the Project
          </div>
          <div className="create-project__step-indicator">
            <Icon type={['far', 'angle-right']} color="grey" size="2x" />
          </div>
        </div>

        <div className="col-12 col-sm-6 col-md-3 create-project__step">
          <div className="create-project__step-icon">
            <Icon type={['fal', 'money-bill']} size="3x" color="green-dark" />
          </div>
          <div className="create-project__step-text">
            CGTrader will pay out the earnings when the Project is done and approved by the client
          </div>
        </div>
      </div>
    </div>
  )
}

export default TopInfoBar
